import { useEffect, useRef, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Sparkles, Users, ArrowRight, Info } from "lucide-react";
import { BrutalButton, BrutalCard } from "@/components/Brutal";
import { useAuth } from "@/context/AuthContext";
import api, { formatError } from "@/lib/api";
import { toast } from "sonner";

export default function Join() {
  const { code } = useParams();
  const navigate = useNavigate();
  const { user, loading } = useAuth();
  const [group, setGroup] = useState(null);
  const accepted = useRef(false);

  useEffect(() => {
    api.get(`/invites/${code}`).then((r) => setGroup(r.data.group)).catch(() => toast.error("Uitnodiging niet gevonden"));
  }, [code]);

  useEffect(() => {
    if (!loading && user === false) navigate(`/login`);
  }, [loading, user, navigate]);

  const accept = async () => {
    if (accepted.current) return;
    accepted.current = true;
    try { await api.post(`/invites/${code}/accept`); toast.success(`Je bent lid van ${group?.name}!`); navigate("/groepen"); }
    catch (e) {
      accepted.current = false;
      if (e.response?.status === 403) {
        toast.error(formatError(e.response?.data?.detail));
        navigate("/aanmelden");
      } else {
        toast.error("Toevoegen mislukt");
      }
    }
  };

  return (
    <div className="min-h-screen bg-brand-cream flex flex-col items-center justify-center p-6">
      <div className="flex items-center gap-3 mb-8">
        <div className="brutal rounded-xl azure-gradient text-white w-12 h-12 flex items-center justify-center"><Sparkles className="w-7 h-7" strokeWidth={3} /></div>
        <span className="font-head font-black text-4xl tracking-tight">Slackr</span>
      </div>
      <BrutalCard className="max-w-md w-full text-center animate-pop">
        <div className="w-16 h-16 brutal-sm rounded-2xl mx-auto flex items-center justify-center text-white mb-4" style={{ backgroundColor: group?.color || "#FF6B00" }}>
          <Users className="w-8 h-8" strokeWidth={2.5} />
        </div>
        <h1 className="font-head font-black text-2xl">Word lid van</h1>
        <p className="font-head font-bold text-3xl text-brand-orange mb-4">{group?.name || "…"}</p>
        <div className="brutal-sm rounded-xl bg-brand-yellow/40 p-3 flex items-start gap-2 mb-4 text-start" data-testid="join-members-only-note">
          <Info className="w-4 h-4 shrink-0 mt-0.5" strokeWidth={2.5} />
          <p className="text-xs font-semibold">Alleen voor bestaande huisgenoten. Nog geen lid? Vraag eerst goedkeuring aan een beheerder.</p>
        </div>
        <BrutalButton data-testid="accept-invite-btn" className="w-full" onClick={accept} disabled={!group}>
          Deelnemen <ArrowRight className="w-5 h-5" strokeWidth={3} />
        </BrutalButton>
      </BrutalCard>
    </div>
  );
}
